import React from "react";
import { Table, TableProps } from "react-bootstrap";

// Custom table for reports: always uses size="sm" and striped, but allows override
const ReportTable: React.FC<TableProps> = ({
	children,
	size = "sm",
	striped = true,
	...rest
}) => (
	<Table size={size} striped={striped} bordered hover {...rest}>
		{children}
	</Table>
);

export default ReportTable;
